module.exports = __webpack_public_path__ + "img/image3.2c76f54f.png";